<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.travel_purpose, 'Scopul călătoriei')"
      :items="purposes"
      item-title="name"
      name="purpose"
      item-value="id"
      v-model="selectedPurpose"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
      :loading="loading"
      :disabled="loading"
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTravelStore } from '~/plugins/store/travel';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { Purpose } from '~/types/Travel';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => Purpose | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-travel-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const travelStore = useTravelStore();
    const translationStore = useTranslationStore();
    const selectedPurpose = ref(modelValue.value ? modelValue.value : null);
    const purposes = ref<Purpose[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);
    const loading = ref(false);

    onMounted(async () => {
      loading.value = true;
      purposes.value = await travelStore.getPurposeList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;
      const isValid = !!selectedPurpose.value;
      emit('validation-travel-status', { field: 'purpose', isValid });
      loading.value = false;

      // Listen for validate event
      window.addEventListener('validate-travel', (data) => {
        if (data.detail && data.detail === 'purpose') {
          if (!selectedPurpose.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-travel-status', { field: 'purpose', isValid: true });
          }
        }
      });
    });

    watch(selectedPurpose, (newPurpose) => {
      if (initialSetupDone) {
        emit('update:modelValue', newPurpose);
      }
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue) {
        selectedPurpose.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-travel-status', { field: 'purpose', isValid });
    });

    return {
      selectedPurpose,
      translationList,
      translation,
      purposes,
      error,
      loading
    };
  },
});
</script>

<style scoped>
</style>